module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-list1"
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/07_Foreword#foreword",
      "id": "toc-foreword"
    }
  }, [_vm._v("Foreword ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list1"
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/08_Introduction#introduction",
      "id": "toc-introduction"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list1"
  }, [_c('a', {
    attrs: {
      "href": "#/09_Chapter1#ch1",
      "id": "toc-ch1"
    }
  }, [_c('b', [_vm._v("Chapter One.")]), _vm._v(" 1914–15. Regular blood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list1"
  }, [_c('span', {
    attrs: {
      "href": "#/10_Chapter2#ch2",
      "id": "toc-ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Two.")]), _vm._v(" 1915–16. Lead us not into temptation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_Chapter3#ch3",
      "id": "toc-ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Three.")]), _vm._v(" 1916. Kitchener’s men.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list1"
  }, [_c('span', {
    attrs: {
      "href": "#/12_Chapter4#ch4",
      "id": "toc-ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Four.")]), _vm._v(" 1916. And the meek shall inherit the earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_Chapter5#ch5",
      "id": "toc-ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Five.")]), _vm._v(" You can’t get away from the guns")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_Chapter6#ch6",
      "id": "toc-ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Six.")]), _vm._v(" 1917. Far, far from Wipers I long to be")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list1"
  }, [_c('span', {
    attrs: {
      "href": "#/15_Chapter7#ch7",
      "id": "toc-ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Seven.")]), _vm._v(" 1917. There is a limit to the number of good men")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list1"
  }, [_c('span', {
    attrs: {
      "href": "#/16_Chapter8#ch8",
      "id": "toc-ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Eight.")]), _vm._v(" 1918. With our backs to the wall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list1"
  }, [_c('span', {
    attrs: {
      "href": "#/17_Chapter9#ch9",
      "id": "toc-ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Nine.")]), _vm._v(" 1918–20. Lord let us now thy servants depart in peace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list1"
  }, [_c('span', {
    attrs: {
      "href": "#/18_Acknowledgement#acknowledgement",
      "id": "toc-acknowledgement",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list1"
  }, [_c('span', {
    attrs: {
      "href": "#/19_Bibliography#bibliography",
      "id": "toc-bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list1"
  }, [_c('span', {
    attrs: {
      "href": "#/20_Appendix#appendix",
      "id": "toc-appendix",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Appendix")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list2"
  }, [_c('span', {
    attrs: {
      "href": "#/20_Appendix#app1",
      "id": "toc-app1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Place of Burial or Commemoration of Executed Men")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list2"
  }, [_c('span', {
    attrs: {
      "href": "#/20_Appendix#app2",
      "id": "toc-app2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Executions in Regimental or Unit Order")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list2"
  }, [_c('span', {
    attrs: {
      "href": "#/20_Appendix#app3",
      "id": "toc-app3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Executions on the Western Front")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list2"
  }, [_c('span', {
    attrs: {
      "href": "#/20_Appendix#app4",
      "id": "toc-app4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Executions in ‘Other Theatres’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list1"
  }, [_c('span', {
    attrs: {
      "href": "#/21_Index#index",
      "id": "toc-index",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Index.")]), _vm._v(" Alphabetical list of all those executed")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent2",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_vm._v("British firing squad in action. The shooting is that of a spy in Belgium early in"), _c('br'), _vm._v("the war. [Penalty not inflicted by authority of the Army Act.]")]), _vm._v(" "), _c('div', {
    staticClass: "paracenter"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/contents-1.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4c57368","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_Contents.vue
// module id = 69
// module chunks = 0